import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding":"20px"}
}
const _hoisted_2 = { style: {"margin-bottom":"20px"} }
const _hoisted_3 = { style: {"margin-bottom":"20px"} }
const _hoisted_4 = { style: {"display":"flex","flex-direction":"row","margin-bottom":"30px"} }
const _hoisted_5 = { style: {"border-radius":"8px","border":"1px solid","width":"200px","height":"200px","display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "Android版", -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"text-align":"center"} }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px"} }, "更新内容：", -1)

import ScPage from '@/components/common/page/ScPage.vue';
import { onMounted, ref } from 'vue';
import { request } from '@/util/request';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppInstaller',
  setup(__props) {

const data = ref();
onMounted(async () => {
  data.value = await request('/management/app_installer/info');
});

return (_ctx: any,_cache: any) => {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_sc_btn = _resolveComponent("sc-btn")!

  return (_openBlock(), _createBlock(ScPage, { title: "应用下载下载" }, {
    default: _withCtx(() => [
      (data.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, "当前版本：" + _toDisplayString(data.value.version), 1),
            _createElementVNode("div", _hoisted_3, " 发布时间： " + _toDisplayString(_unref(dayjs)(Number(data.value.createTime)).format('YYYY-MM-DD')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_sc_icon, {
                    type: "AndroidFilled",
                    style: {"color":"#2ecc7d","font-size":"24px","margin-right":"8px"}
                  }),
                  _hoisted_7
                ]),
                _createElementVNode("img", {
                  src: data.value.androidQr,
                  style: {"width":"120px","height":"120px"}
                }, null, 8, _hoisted_8),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("a", {
                    href: data.value.android,
                    target: "_blank"
                  }, [
                    _createVNode(_component_sc_btn, {
                      type: "link",
                      text: "点击下载"
                    })
                  ], 8, _hoisted_10)
                ])
              ])
            ]),
            _hoisted_11,
            _createElementVNode("div", {
              style: _normalizeStyle({color: !data.value.desc ? '#AAA' : undefined})
            }, _toDisplayString(data.value.desc || '暂无说明'), 5)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})